import { useEffect, useState } from 'react';

import NewsCard from '../../components/News/NewsCard';
import NewsCategories from '../../components/News/NewsCategories';

import '../../utils/styles/News.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import { API } from '../../utils/hooks';

function News() {
    // Add a state to keep track of the active category
    const [activeCategory, setActiveCategory] = useState('');

    // infinite scroll (pagination)
    const [news, setNews] = useState([]);
    const [page, setPage] = useState('news/');
    const [switchPage, SetSwitchPage] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        async function fetchData() {
            try {
                if (page) {
                    const response = await API.get(page);
                    const prev = news.slice(); // Copy the previous state
                    setNews([...prev, ...response.data.results]);
                    setPage(response.data.next);
                }
                SetSwitchPage(false);
            } catch (error) {
                console.log(error.message);
            } finally {
                setLoading(false);
            }
        }
        fetchData();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [switchPage]);

    // Function to handle the scroll event
    const handleScroll = () => {
        if (
            window.innerHeight + document.documentElement.scrollTop + 1 >=
            document.documentElement.offsetHeight
        ) {
            setLoading(true);
            SetSwitchPage(true);
        }
    };

    // Add an event listener to the window to listen for the scroll event
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [switchPage]);

    return (
        <div className="container">
            <p className="title-3">Actualités</p>

            <NewsCategories
                setActiveCategory={setActiveCategory}
                activeCategory={activeCategory}
            />

            <div className="all-news">
                {news &&
                    news.map(
                        ({ id, title, timestamp, author, img, category }) =>
                            !activeCategory ||
                            activeCategory === category.name ? (
                                <NewsCard
                                    key={id}
                                    id={id}
                                    title={title}
                                    date={timestamp}
                                    author={author}
                                    img={img}
                                />
                            ) : null
                    )}
            </div>

            {loading && (
                <div className="loading">
                    <FontAwesomeIcon icon={faSpinner} className="fa-spin" />
                </div>
            )}
        </div>
    );
}

export default News;
